var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 68,
    viewBox: "0 0 65 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.17089,
    y1: 43.377,
    x2: 64.0732,
    y2: 43.377,
    stroke: "#828282",
    strokeWidth: 1.09765,
    strokeLinecap: "round",
    strokeDasharray: "2.2 2.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1416 43.2033C15.5788 35.1098 16.7154 17.3041 17.7646 10.8293C18.2017 7.88619 19.6006 2 21.699 2C23.0105 2 25.6334 3.76586 25.6334 10.8293C25.852 23.5827 26.4203 49.3839 26.9449 50.5611C27.6006 53.0137 29.4367 57.3302 31.535 54.9757C32.6279 54.4852 34.8137 55.27 34.8137 62.3335C35.9066 66.0123 38.4859 70.1327 40.0596 57.1831C40.4968 50.5611 42.4203 37.6115 46.617 38.7887C47.4913 38.7887 49.6334 39.9659 51.2072 44.6749C51.6443 45.1654 53.0432 45.5578 55.1416 43.2033",
    stroke: "#66FCF1",
    strokeWidth: 2.42759,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartF);
export default __webpack_public_path__ + "static/media/chartF.bb24edfe76af700bbdd7036f5d8c4948.svg";
export { ForwardRef as ReactComponent };